import { ACTION_TYPES } from './fees.constant';

export const serviceGet = () => ({
  type: ACTION_TYPES.SERVICE.GET,
});

export const serviceGetLink = () => ({
  type: ACTION_TYPES.SERVICE.GET_LINK,
});

export const fetchStart = () => ({
  type: ACTION_TYPES.FETCH.START,
});

export const fetchSuccess = (payload) => ({
  type: ACTION_TYPES.FETCH.SUCCESS,
  payload,
});

export const fetchSuccessLink = (payload) => ({
  type: ACTION_TYPES.FETCH.SUCCESS_LINK,
  payload,
});

export const fetchError = () => ({
  type: ACTION_TYPES.FETCH.ERROR,
});

export const resetState = () => ({
  type: ACTION_TYPES.RESET.STATE,
});
